import React, { useEffect, useState } from 'react'
import './inquiries-allocated-card.scss'
import rightArrow from "../../../assets/images/home-internal-user-flow-rightarrow.svg";
import { Col, DatePicker, notification, Row, Spin, Radio } from 'antd'
import { useStore } from '../../../store/store';
import { FulfilmentDashboardMetric } from '../../../service/fulfilment/fulfilmentService';

import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { NULL } from 'sass';

const InquiriesAllocatedCard = ({ activeTab, data, fulfilmentFilter, setFulfilmentFilter, filterLoader, getCurrentDateFn, page }) => {
  const { user, saveUser } = useStore();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isactiveTab, setActiveTab] = useState(activeTab)
  const [isloading, setLoading] = useState(true)
  const [fulfilmentDashboardData, setFulfilmentDashboardData] = useState({})


  const [inquiriesAllocated, setInquiriesAllocated] = useState([]);
  const [formFilterState, setFormFilterState] = useState({
    // moveType: [],
    // orderId: "",
    activeFilter: "currentMonth",
    fromDate: moment().startOf('month').startOf('day').toISOString(),
    toDate: moment().endOf('month').endOf('day').toISOString(),
  });
  const { RangePicker } = DatePicker;




  const quickfilters = [
    { key: "currentMonth", label: t("EARNING_CURRENT_MONTH") },
    { key: "last7Days", label: t("EARNING_LAST_DAY") },
    { key: "last1Month", label: "Last 1 Month" },
    { key: "last3Months", label: t("EARNING_LAST_MONTH") },
    // ...(activeTransactionTab === "Payments"
    //   ? [{ key: "filters", label: t("EARNING_FILTERS") }]
    //   : []),
  ]

  useEffect(() => {

    setFulfilmentDashboardData(data)
    setActiveTab(activeTab);
    if (data?.done && data?.pending) {
      setInquiriesAllocated([
        { "type": t("FULLFILLMENT_BID"), "upto": `${activeTab === 'completed' ? data?.done?.bid : data?.pending?.bid}`, "total": `${activeTab === 'completed' ? data?.done?.totalBid : data?.pending?.totalBid}`, "link": `${(activeTab === 'pending' && data?.pending?.bid > 0) ? "/loads" : ""}` },
        { "type": t("FULLFILLMENT_WINNER"), "upto": `${activeTab === 'completed' ? data?.done?.winner : data?.pending?.winner}`, "total": `${activeTab === 'completed' ? data?.done?.totalWinner : data?.pending?.totalWinner}`, "link": `${(activeTab === 'pending' && data?.pending?.winner > 0) ? "/my-bids/awarded" : ""}` },
        { "type": t("FULLFILLMENT_MARGIN_APPROVAL"), "upto": `${activeTab === 'completed' ? data?.done?.marginApproval : data?.pending?.marginApproval}`, "total": `${activeTab === 'completed' ? data?.done?.totalMarginApproval : data?.pending?.totalMarginApproval}`, "link": "" },
        { "type": t("LOADS_ASSIGNMENT"), "upto": `${activeTab === 'completed' ? data?.done?.assignment : data?.pending?.assignment}`, "total": `${activeTab === 'completed' ? data?.done?.totalAssignment : data?.pending?.totalAssignment}`, "link": `${(activeTab === 'pending' && data?.pending?.assignment > 0) ? "/my-bids/awarded" : ""}` },
        { "type": t("FULLFILLMENT_DRT"), "upto": `${activeTab === 'completed' ? data?.done?.drt : data?.pending?.drt}`, "total": `${activeTab === 'completed' ? data?.done?.totalDrt : data?.pending?.totalDrt}` },
        { "type": t("LOADS_BOOKING"), "upto": `${activeTab === 'completed' ? data?.done?.booking : data?.pending?.booking}`, "total": `${activeTab === 'completed' ? data?.done?.totalBooking : data?.pending?.totalBooking}`, "link": "" },
      ]);
      setLoading(false);
    }
  }, [data, activeTab]);



  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      const fromDate = dates[0].format("YYYY-MM-DD");
      const toDate = dates[1].format("YYYY-MM-DD");
      console.log(fromDate, toDate, 'yghjkjhghjkilhjgj')

      setFulfilmentFilter(prev => ({
        ...prev,
        moveDate: {
          fromDate,
          toDate,
        },
      }));
      // setDefaultDateFlag(true)
      setFormFilterState((prev) => ({
        ...prev,
        activeFilter: ''


      }))

    }
  };





  const handleCardClick = (link) => {
    if (link) {
      navigate(link);
    }
  };








  const handleFilterChange = (e) => {
    //   ledgerFilterForm.resetFields()
    const selectedFilter = e.target.value;
    let newFromDate, newToDate;
    // setDefaultDateFlag(false)

    // Adjust fromDate and toDate based on the selected filter
    if (selectedFilter === "currentMonth") {
      newFromDate = moment.utc().startOf('month').toISOString();
      newToDate = moment().endOf('month').toDate().toISOString();     // Last day of month at 23:59:59.999Z

    } else if (selectedFilter === "last7Days") {
      newFromDate = moment().subtract(7, 'days').startOf('day').toISOString();
      newToDate = moment().endOf('day').toISOString();
    } else if (selectedFilter === "last3Months") {
      newFromDate = moment().subtract(3, 'months').startOf('month').toISOString();
      newToDate = moment().endOf('day').toISOString();
    } else if (selectedFilter === "last1Month") {
      newFromDate = moment().subtract(1, 'month').startOf('day').toISOString();
      newToDate = moment().endOf('day').toISOString();
    }


    const updatedState = {
      activeFilter: selectedFilter,
      fromDate: newFromDate,
      toDate: newToDate,
    };
    //   ledgerFilterForm.setFieldValue("filterDateRange", [dayjs(newFromDate), dayjs(newToDate)])
    setFormFilterState((prevState) => ({
      ...prevState,
      activeFilter: selectedFilter,
      fromDate: newFromDate,
      toDate: newToDate,
    }));

    getCurrentDateFn(updatedState);

  };


  return (
    <>
      {
        (isloading) ?
          <div className="loading">
            <Spin style={{ marginLeft: "50%", marginTop: "10%" }} />
          </div>
          :
          <Row className="Inquiries-wrapper-ful">
            <Row className="Inquirires-allocated">
              {/* <span>{t("HOME_INQUIRY_ALLOCATED_MSG")}<span className="inquiries-value">{data?.totalAllocatedInquiry}</span></span> */}
              <Radio.Group
                value={formFilterState.activeFilter}
                onChange={handleFilterChange}
                className="filter-radio-group-btn"

              >
                {quickfilters.map((filter) => (
                  <Radio.Button key={filter.key} value={filter.key} >
                    {filter.label}
                  </Radio.Button>
                ))}
              </Radio.Group>

              {page !== 'home' && (
                (filterLoader) ? <div>
                  <Spin style={{ marginRight: '40px' }} />
                </div> :
                  <span className='orders-input-group'>
                    <RangePicker

                      className="orders-custom-input"
                      value={[
                        fulfilmentFilter.moveDate.fromDate
                          ? dayjs(fulfilmentFilter.moveDate.fromDate)
                          : null,
                        fulfilmentFilter.moveDate.toDate
                          ? dayjs(fulfilmentFilter.moveDate.toDate)
                          : null,
                      ]}
                      onChange={handleDateChange}
                      placeholder={[t("LOADS_FILTER_START_DATE"), t("LOADS_FILTER_END_DATE")]}
                    />
                    <label className="orders-input-label">{t("LOADS_DATE_RANGE")}</label>
                  </span>
              )}

            </Row>
            <span className='inquiries-allocated'>{t("HOME_INQUIRY_ALLOCATED_MSG")}
              {/* <span className="inquiries-value">{data?.totalAllocatedInquiry}</span> */}
              <span className="circle">
                {data?.totalAllocatedInquiry}
              </span>
            </span>


            {
              filterLoader ?
                <div>
                  <Spin style={{ marginLeft: "50%" }} />
                </div>
                :
                <Row className='inquiries-card-wrapper'>
                  {inquiriesAllocated?.map((items, index) => (
                    <Col key={index} span={8} className="InquiriesCard-wrapper">
                      <div className="inquiries-card-ful">
                        <div className="inquiries-card-firstrow">
                          <span>
                            <span className="inquiries-card-upto">{items?.upto}<span className="inquiries-card-totalvalue"> /{items.total}</span></span>
                          </span>
                          <span style={{ cursor: 'pointer' }} onClick={() => handleCardClick(items.link)}><img src={rightArrow} alt="click" /></span>
                        </div>
                        <div className="inquiries-card-type">{items?.type}</div>
                      </div>
                    </Col>
                  ))}
                </Row>
            }

          </Row>
      }
    </>
  )
}
export default InquiriesAllocatedCard